module.exports = __webpack_public_path__ + "static/media/File_icon.2765503b.png";